import { Outlet } from "react-router-dom";
import "./index.scss";
import img from "src/assets/images/resale-layout/resale-bg.svg";
import { useEffect } from "react";
import HeaderResaleComponent from "src/components/header-resale";
import FooterComponent from "src/components/footer";

interface IProps {
  isHeader?: boolean;
}

function BaseResaleLayoutComponent({ isHeader = false }: IProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {isHeader && <HeaderResaleComponent isTopPage={true} />}
      <div className="BaseResaleLayoutStyle">
        <div className="position-relative">
          <img
            src={img}
            alt=""
            style={{ width: "100%", height: 420, objectFit: "cover" }}
          />
          <div className="nafutel-blur"></div>
        </div>
        <div className="WrapLayout">
          <Outlet />
        </div>
      </div>
      {isHeader && <FooterComponent isResale={true} />}
    </>
  );
}

export default BaseResaleLayoutComponent;
